import { Color } from 'src/app/shared/enum/color.enum';

export class SvgVM {
  urlFile?: string;
  color: string;
  colorActive: string;
  isActive: boolean;

  constructor(
    urlFile?: string,
    color: string = Color.Black,
    colorActive: string = Color.White,
    isActive: boolean = false,
  ) {
    this.urlFile = urlFile;
    this.color = color;
    this.colorActive = colorActive;
    this.isActive = isActive;
  }
}
